import React, { useEffect, useState } from "react";
import {
  I2cInput,
  I2cRadio,
  I2cRadioGroup,
  I2cListItem,
  I2cTooltip,
  I2cIcon,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import { validationSchema } from "./validationSchema";
import {
  geographical_Region_Selection,
} from "./FieldsListingLabels";

const GeographicRegionSelection = ({
  type,
  setFormValidStates,
  setAddFormData,
  addFormData,
  formDataJson,
  isFetching,
}) => {
  const [selectedDataMigType, setDataMigTypeChange] = useState(null);
  // Define validation schema using Yup
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      geographical_regions_selection: "",
      geographical_regions_details_others: "",
    },
  });

  const fields = [
    "geographical_regions_selection",
    "geographical_regions_details_others",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[0]["0_0"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Controlls destructuring from the method
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      0: {
        ...addFormData["0"],
        "0_0": { ...values },
      },
    });
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("0_0", true);
  };
  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("0_0", true);
    else setFormValidStates("0_0", false);
    handleValueChanges();
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="custom-label-cholder">
     
        Issuers can launch card programs in different global regions. This information is important because setup and regulatory requirements can vary for different regions.
      </div>
      <div className="forms-instance">
        <div className="section-space" i2c-grid="grid gap-md">
          <div i2c-grid="12" className="single-field-wrapper">
            <Controller
              name="geographical_regions_selection"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  {...field}
                  label="Please select the region(s) where you want to launch the card program."
                  onI2cChange={(e) => {
                    methods.setValue("geographical_regions_selection", e.target.value);
                    methods.setValue("geographical_regions_details_others", "");
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  <div i2c-grid="grid gap-sm">
                    {geographical_Region_Selection.map((grs, index) => (
                      <div i2c-grid="12 6@sm 4@md 2@lg" key={`${grs.value}-${index}`}>
                        <div className="map-radiobox-wrapper mb-8">
                          <I2cListItem
                            key={grs.value}
                            variant="receipt"
                            label={false}
                            sublabel=""
                            value=""
                            checked={methods.watch("geographical_regions_selection") === grs.value}
                            type="checkbox"
                            className="map-radio-list-item"
                          >
                            <I2cRadio
                              slot="prefix"
                              name="credit_programType"
                              value={grs.value}
                              filled
                              label=""
                              checked={
                                methods.watch("geographical_regions_selection") === grs.value
                              }
                            />
                            <img className="map-radio-img" src={grs.img} alt={grs.label} slot="prefix" />
                          </I2cListItem>
                        </div>
                        <div className="map-radio-label">{grs.label}</div>
                      </div>
                    ))}
                  </div>
                </I2cRadioGroup>
              )}
            />
          </div>
          {
            methods.watch('geographical_regions_selection') === 'Other' &&
            <div i2c-grid="6@md"  className="single-field-wrapper">
              <Controller
                name="geographical_regions_details_others"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    className="single-input-field"
                    placeholder="Other Details"
                    required
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      methods.trigger();
                      handleValueChanges();
                    }}
                    size="large"
                    name={"geographical_regions_details_others"}
                  >
                    <span slot="label" className="organize-tooltip">
                      <span className="custom-label">
                        {" "}
                        Enter Details
                      </span>
                    </span>
                  </I2cInput>
                )}
              />
            </div>
          }
        </div>
      </div>
    </React.Fragment>
  );
};

export default GeographicRegionSelection;
